module.exports = __webpack_public_path__ + "static/media/D-DINCondensed.2c8b34e4.otf";